import { Injectable } from '@angular/core';
import { WebApiLocationService } from '@core/services/web-api-location.service';

@Injectable({
    providedIn: 'root'
})
export class LocationService {
    constructor(private defaultLocationService: WebApiLocationService) {}

    fetchLocation() {
        return this.defaultLocationService.getCurrentLocation();
    }
}
